import React, { Component } from "react";
import { View, Image, TouchableOpacity, ScrollView, Dimensions } from 'react-native'
import { icons } from "../theme/icons";
import { appStyles, profileStyles } from '../theme/styles'
import TextView from "../components/TextView";
import LinearGradient from 'react-native-linear-gradient';
import { blueDarkColor, blueLightColor } from "../theme/colors";
import EditText from "../components/EditText";
import { myProfileRequest } from "../utils/api";
import Waiting from "../components/Waiting";
import DialogMessage from "../components/DialogMessage";
var { width, height } = Dimensions.get('window');

export default class ProfileScreen extends Component {
    constructor(props) {
        super(props)
        this.state = {
            first_name: '',
            last_name: '',
            phone: '',
            koche: '',
            vahed: '',
            pelak: '',
            address: '',
            national_code: '',
            mobile: '',
            email: '',
            waiting: true,
            cityModal: false,
            areaModal: false,
            showMessage: false,
            messageTitle: '',
            messageContent: '',
            messageSucces: false,
            cities: [],
            areas: [],
            selectedCity: null,
            selectedArea: null,
            selectedBimeh: { id: 0 },
            bimeCode: '',
            bimeDate: '',
            lat: '',
            lng: '',
            gender: 0,
        }
    }

    render() {
        return (<View style={appStyles.flex1}>
            <View style={appStyles.toolbarWraper}>
                <Image source={icons['ad']} style={[appStyles.toolbarIcon, { tintColor: '#31BFCF' }]} />
                <TextView style={appStyles.toolbarTitle}>اطلاعات کاربری</TextView>
                <TouchableOpacity onPress={() => {
                    this.props.navigation.goBack()
                }}>
                    <Image source={icons['back']} style={appStyles.backIcon} />
                </TouchableOpacity>
            </View>
            <LinearGradient colors={[blueDarkColor, blueLightColor]} style={profileStyles.wraper}>
                <ScrollView>
                    <EditText
                        hint='نام'
                        hintColor='#ffffffcc'
                        style={profileStyles.textInput}
                        onChangeText={(text) => {
                            this.setState({
                                first_name: text
                            })
                        }}
                        value={this.state.first_name}
                    />
                    <EditText
                        hint='نام خانوادگی'
                        hintColor='#ffffffcc'
                        style={profileStyles.textInput}
                        onChangeText={(text) => {
                            this.setState({
                                last_name: text
                            })
                        }}
                        value={this.state.last_name}
                    />
                    <EditText
                        hint='ایمیل'
                        hintColor='#ffffffcc'
                        textStyle={{ width: width - 90 }}
                        style={profileStyles.textInput}
                        onChangeText={(text) => {
                            this.setState({
                                email: text
                            })
                        }}
                        value={this.state.email}
                    />
                    <EditText
                        hint='تلفن ثابت'
                        hintColor='#ffffffcc'
                        inputType='numeric'
                        textStyle={{ width: width - 90 }}
                        style={profileStyles.textInput}
                        onChangeText={(text) => {
                            this.setState({
                                phone: text
                            })
                        }}
                        value={this.state.phone}
                    />

                    <EditText
                        hint='آدرس'
                        style={profileStyles.textInput}
                        hintColor='#ffffffcc'
                        onChangeText={(text) => {
                            this.setState({
                                address: text
                            })
                        }}
                        value={this.state.address}
                    />
                    <EditText
                        hint='کد ملی'
                        style={profileStyles.textInput}
                        hintColor='#ffffffcc'
                        inputType='numeric'
                        onChangeText={(text) => {
                            this.setState({
                                national_code: text
                            })
                        }}
                        value={this.state.national_code}
                    />
                </ScrollView>

                <View style={[appStyles.bottomView, appStyles.center]}>

                    <TextView style={{ textAlign: 'center', fontSize: 12 }}>سفیر محترم جهت ویرایش اطلاعات با پشتیبانی در ارتباط باشید</TextView>
                </View>
            </LinearGradient>

            <DialogMessage
                show={this.state.showMessage}
                title={this.state.messageTitle}
                message={this.state.messageContent}
                onClose={() => {
                    this.setState({
                        showMessage: false
                    })
                    if (this.state.messageSucces) {
                        this.props.navigation.goBack()
                    }
                }} />
            <Waiting waiting={this.state.waiting} />
        </View>)
    }

    componentWillMount() {
        myProfileRequest((isConnect, response) => {
            this.setState({
                waiting: false
            })
            if (isConnect && response.isSuccess) {
                var user = response.data;
                var selectedArea = null;
                var selectedCity = null;
                if (user.areanumber != null) {
                    selectedArea = { id: user.areanumber, name: user.areaname, number: user.areanumber }
                }
                if (user.cityid != null) {
                    selectedCity = { name: user.cityname, id: user.cityid }
                }
                this.setState({
                    first_name: user.fname,
                    last_name: user.lname,
                    email: user.email,
                    koche: user.koche,
                    vahed: user.vahed,
                    pelak: user.pelak,
                    phone: user.phone,
                    address: user.address,
                    selectedArea: selectedArea,
                    selectedCity: selectedCity,
                    national_code: user.ncode
                })
            }
        })

    }
}